import { render, staticRenderFns } from "./CaseEyes.vue?vue&type=template&id=665f4a5e&scoped=true&"
import script from "./CaseEyes.vue?vue&type=script&lang=js&"
export * from "./CaseEyes.vue?vue&type=script&lang=js&"
import style0 from "./CaseEyes.vue?vue&type=style&index=0&id=665f4a5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665f4a5e",
  null
  
)

export default component.exports